import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import { UnWrappedColumn, tableAddressColumnStyles } from '../styles';
import addressFilter from '../address-filter';

const RequestLogTableRow = ({ fuelCard }) => (
  <TableRow>
    <TableRowColumn>#{fuelCard.requestId}</TableRowColumn>
    <TableRowColumn>#{fuelCard.leaseId}</TableRowColumn>
    <TableRowColumn>{fuelCard.registration}</TableRowColumn>
    <TableRowColumn>{fuelCard.driver}</TableRowColumn>
    <TableRowColumn style={tableAddressColumnStyles}>
      <UnWrappedColumn>{addressFilter(fuelCard.address)}</UnWrappedColumn>
    </TableRowColumn>
  </TableRow>
);

RequestLogTableRow.propTypes = {
  /**
   * The fuel card which will be displayed for this table row
   */
  fuelCard: PropTypes.object.isRequired
};

export default RequestLogTableRow;



// WEBPACK FOOTER //
// ./src/features/fuel-cards/request-log-table/request-log-table-row.js